import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=c90c2444&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=c90c2444&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90c2444",
  null
  
)

export default component.exports